import { render, staticRenderFns } from "./VersionDuplicate.vue?vue&type=template&id=300c0ad8&lang=pug"
import script from "./VersionDuplicate.vue?vue&type=script&lang=js"
export * from "./VersionDuplicate.vue?vue&type=script&lang=js"
import style0 from "./VersionDuplicate.vue?vue&type=style&index=0&id=300c0ad8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports